import React from 'react';
import styled, { keyframes } from 'styled-components';
import { IoDocumentText } from "react-icons/io5";

// Keyframes for the animation
const pulseAnimation = keyframes`
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 var(--color-brand-800);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(0, 123, 255, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 123, 255, 0);
  }
`;

const Button = styled.button`
  padding: 10px 20px;
  font-size: 16px;
  background-color: rgba(2, 2, 2, 0.1);
  color: #eee;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;
  animation: ${pulseAnimation} 2s infinite;
  display: flex;
  align-items: center;
  gap: 10px;
  z-index: 999;
  margin-top: 1.4rem;
  &:hover {
    outline: none;
    background-color: #4caf50;
    transform: scale(1.05);
  }
`;

const ResumeButtonIcon = styled.span`
  font-size: 20px;
`;

const ResumeButtonText = styled.span`
  font-weight: bold;
`;

const openResumePage = (resumeUrl) => {
  const newWindow = window.open('', '_blank');
  if (newWindow) {
    newWindow.document.write(`
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Resume</title>
        <style>
          body {
            margin: 0;
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
            background-color: rgb(36, 41, 56);
          }
          
          iframe {
            width: 70%;
            height: 100%;
            border: none;
          }
          @media (max-width: 768px) {
            iframe {
              width: 100%;
            }
          }
        </style>

      </head>
      <body>
        <iframe src="${resumeUrl}"></iframe>
      </body>
      </html>
    `);
    newWindow.document.close();
  } else {
    alert('Popup blocked! Please allow popups for this site.');
  }
};

const ResumeButton = ({ resumeUrl }) => {
  return (
    <Button onClick={() => openResumePage(resumeUrl)}>
      <ResumeButtonIcon>
        <IoDocumentText />
      </ResumeButtonIcon>
      <ResumeButtonText>View Resume</ResumeButtonText>
    </Button>
  );
};

export default ResumeButton;
